import React, { Component } from "react";
import { observer } from "mobx-react";
import { commaString, partnerIcon, getOrderTypeStyle } from "utils/Utils";
import { fn_orderListClear } from "../../../function/FnBodyOrder";

@observer
class SaleWriteListView extends Component {
    constructor(props) {
        super(props);

    }

    render() {
        const { rootStore, obj } = this.props;
        let img_icon = partnerIcon(obj.orderChannel)
        let won = obj.paymentAmount
        let orderTypeStyle = getOrderTypeStyle(obj.orderType);

        return (
            <li id={"list" + obj.id}>
                <img src={img_icon} width="30" height="30" alt={"logo"} />
                <span className={"type " + orderTypeStyle}>{obj.orderTypeTxt}</span>
                <span className="pay">{obj.paymentTypeTxt}</span>
                <span className="money">{commaString(won)} 원</span>
                <span className="clear"
                    onClick={event => {
                        rootStore.layerStore.setLayerSaleWriteCloseView("view", true);
                        rootStore.layerStore.setLayerSaleWriteCloseView("id", obj.id);
                    }}
                ></span>
            </li>
        );
    }
}

export default SaleWriteListView;